import Checkbox from 'components/inputs/Checkbox';
import FilterSectionContext from 'contexts/FilterSectionContext';
import React, { useContext } from 'react';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  text: string;
  disabled: boolean;
}

const SingleFilter: React.FC<Props> = (props: Props) => {
  const { checked, onChange, text, disabled } = props;

  const { sectionOpen } = useContext(FilterSectionContext);

  const handleCheckboxClick = (): void => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return sectionOpen === null ? (
    <div
      className="hrem-2p75 px4 row items-center bb-2 cursor-pointer"
      style={{ opacity: disabled ? '0.5' : '1' }}
      onClick={handleCheckboxClick}
    >
      <Checkbox
        className="filter-popover--single-filter"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="ml2 disable-select">{text}</span>
    </div>
  ) : null;
};

export default SingleFilter;
